import { Directive, HostBinding } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[campusReward], [campus-reward], campus-reward',
})
export class RewardDirective {
  @HostBinding('class')
  defaultClasses = ['block'];
}
